// 上传前获取签名串
import Request from 'utils/request';
import Util from 'utils';
import config from 'config/Config';
import dayjs from 'dayjs';
import { hex_md5 } from 'utils/md5';

const getRandomIntInclusive = function (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; // 含最大值，含最小值
};
function random_string(len) {
  len = len || 32;
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const maxPos = chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

function get_suffix(filename) {
  const pos = filename.lastIndexOf('.');
  let suffix = '';
  if (pos != -1) {
    suffix = filename.substring(pos);
  }
  return suffix;
}

function parseAjaxResponse(xhr) {
  const responseText = xhr.responseText || '';
  if (!responseText) {
    return {};
  }

  try {
    return JSON.parse(responseText);
  } catch (error) {
    return responseText;
  }
}

function ajaxByXHR(options = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const method = options.type || options.method || 'GET';

    xhr.open(method, options.url, true);
    Object.keys(options.headers || {}).forEach((key) => {
      xhr.setRequestHeader(key, options.headers[key]);
    });

    if (options.contentType) {
      xhr.setRequestHeader('Content-Type', options.contentType);
    }

    xhr.onload = () => {
      const response = parseAjaxResponse(xhr);
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(response);
        return;
      }
      reject(response || xhr);
    };
    xhr.onerror = () => reject(xhr);
    xhr.ontimeout = () => reject(xhr);
    xhr.send(options.data || null);
  });
}

// 图片上传前触发
function beforeUpload(file) {
  return new Promise((resolve, reject) => {
    const isJPG =
      file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
    if (!isJPG) {
      reject(new Error('你只能上传图片格式的文件!'));
    }
    const isLt20M = file.size / 1024 / 1024 < 20;
    if (!isLt20M) {
      reject(new Error('图片必须小于20MB!'));
    }

    if (isJPG && isLt20M) {
      resolve(true);
    }
  });
}

// 附件上传前触发
function beforeAnnexUpload(file, type = 1) {
  console.log('file >> ', file);
  return new Promise((resolve, reject) => {
    if (type == 1) {
      const isLt20M = file.size / 1024 / 1024 < 20;
      isLt20M ? resolve(true) : reject('附件必须小于20MB!');
    } else {
      const isLt550M = file.size / 1024 / 1024 < 500;
      isLt550M ? resolve(true) : reject('附件必须小于500MB!');
    }
  });
}

// /**
//  *
//  * @param {*} g_dirname 路径
//  * @param {*} filename 文件名
//  */
// function calculate_object_name(g_dirname, filename) {
//   if (!filename) {
//     return '';
//   }

//   const suffix = get_suffix(filename);

//   let g_object_name = g_dirname + random_string(10) + suffix;

//   return g_object_name;
// }

/** 混淆文件名
 *
 * @param {string} g_dirname 目录名
 * @param {*} group
 * @param {string} filename 文件名
 * @param {boolean} isReal 是否不混淆
 * @param {string|Function} customFileName 自定义文件名，
 *      若传入string，则拼接到原文件名后，传入内容为withTime时，自动拼接时间戳
 *      若传入函数，则将函数返回值作为文件名,函数会有两个形参(文件名，后缀名)
 */
function calculate_object_name(g_dirname, group, filename, isReal, customFileName) {
  if (!filename) {
    return '';
  }

  if (isReal) {
    if (group) {
      return `${g_dirname}group/${filename}`;
    }
    return `${g_dirname}${filename}`;
  }

  let suffix = get_suffix(filename);
  if (group) {
    if (g_dirname.indexOf('/') == -1) {
      g_dirname += '/';
    }
    g_dirname += `${group}/`;
  }
  if (customFileName) {
    // 自定义文件名流程
    const originName = filename.substring(0, filename.indexOf(suffix));
    if (typeof customFileName === 'string') {
      // 如果传入withTime，则自动拼接时间戳（精确到秒而不是毫秒）+4位乱码
      if (customFileName === 'withTime') {
        customFileName = dayjs().unix() + random_string(4);
      }
      return `${g_dirname + originName}-${customFileName + suffix}`;
    }
    return customFileName(originName, suffix);
  }

  let g_object_name = decodeURIComponent(g_dirname + random_string(10) + suffix);

  return g_object_name;
}

// 获取OSS上传配置
function getUploadCfg(file, cardCode) {
  let params = {};
  params.platform = 'h5';
  params.cardcode = cardCode;
  return Request({
    url: 'api/log/upload-url',
    host: config.HOST_UPLOAD_TOKEN,
    withCredentials: false,
    params
  })
    .then((res) => {
      const { cdnHost, key, policy, AccessKeyId, signature, 'x-obs-acl': xObsAcl } = res.data || {};
      console.warn('上传路径:', key);
      const uploadCfg = {};
      uploadCfg.uploadImgServer = cdnHost;
      uploadCfg.uploadImgParams = {
        'x-obs-acl': xObsAcl || 'public-read',
        key: key,
        policy: policy,
        AccessKeyId: AccessKeyId,
        signature: signature
      };
      uploadCfg.file = file;
      return uploadCfg;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// 上传对象到OSS
function postObject2OSS(uploadCfg, option = { isPrivate: false }) {
  // FormData对象
  const formData = new FormData();

  // 附加参数
  const ump = uploadCfg.uploadImgParams;
  Object.keys(ump).map((k) => {
    if (k !== 'cdnHost') {
      formData.append(k, ump[k]);
    }
  });
  formData.append('file', uploadCfg.file);

  // 上传文件
  return ajaxByXHR({
    url: uploadCfg.uploadImgServer,
    type: 'POST',
    data: formData
  })
    .then(function () {
      const imgUrl = `${uploadCfg.uploadImgServer}/${ump.key}`; // 加密的时候用图片
      const cdnImgUrl = `${
        uploadCfg.uploadImgParams.cdnHost || uploadCfg.uploadImgServer
      }/${ump.key}`;
      console.log('>>>上传成功返回url', option.isPrivate, imgUrl);
      // 上传到华为public仓库时，直接返回imgUrl，该链接可直接访问
      if (!option.isPrivate) return cdnImgUrl;
      // 上传到华为private仓库时，imgUrl链接无法直接访问，需要在调用接口获取临时的图片url
      let key = hex_md5(`${imgUrl.substring(imgUrl.length - 8)}bucketKey666`);
      let auth = Util.getLocalCache(config.localStorageKeys.member_token);
      const time = new Date().getTime();
      let jsonStr = JSON.stringify({
        key,
        url: imgUrl
      });

      return ajaxByXHR({
        url: `${config.HOST_MALL}/v2/huieryun/objectstorage/policy/url/sts`,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        headers: {
          'Access-Token': auth,
          'biz-timestamp': time,
          'biz-route': encodeURIComponent((window.location.hash || '').replace(/^#/, '') || window.location.pathname),
          'biz-sign': hex_md5(`${'biz-timestamp'}${time}${jsonStr}`).toLowerCase(),
          'biz-sign1': `${'biz-timestamp'}${time}${jsonStr}`.toLowerCase()
        },
        data: jsonStr
      }).then(function (res_2) {
        return res_2.data;
      });
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

/**
 * 图片压缩
 * @params {File} file
 * @params {Object} option 图片质量配置
 * @params {Function} callback
 */
function filecCmpress(file, option, callback) {
  let formFile = null;
  console.log('source file', file);
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    // canvas压缩图片
    let img = new Image();
    img.src = reader.result;
    img.onload = () => {
      // 默认按比例压缩
      let w = img.width;

      let h = img.height;

      let scale = w / h;
      // 设置图片质量
      let quality = 0.5;
      if (option.quality && option.quality <= 1 && option.quality > 0) {
        quality = option.quality;
      }
      w = w > 300 ? w * quality : w;
      h = w > 300 ? w / scale : h;
      // 生成canvas
      let canvas = document.createElement('canvas');

      let ctx = canvas.getContext('2d');
      canvas.width = w;
      canvas.height = h;
      ctx.drawImage(img, 0, 0, w, h);
      let base64 = canvas.toDataURL(file.type, quality);
      // base64编码图片转为File类型
      let arr = base64.split(',');

      let mime = arr[0].match(/:(.*?);/)[1];

      let bstr = atob(arr[1]);

      let n = bstr.length;

      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      formFile = new window.File([new Blob([u8arr], { type: mime })], file.name, {
        type: file.type
      });
      console.log('end file', formFile);
      callback(formFile);
    };
  };
}

/**
 * 上传文件至接口
 * @param {File} file - 文件
 * @param {String} scene - 场景编码
 * @returns
 */
function uploadFileMall({ file = {}, scene = 'other' }) {
  const formData = new FormData();

  let auth = Util.getLocalCache(config.localStorageKeys.member_token);
  const time = new Date().getTime();

  formData.append('file', file || '');
  return ajaxByXHR({
    url: `${config.HOST_MALL}/v1/access/upload/${scene || 'scene'}`,
    type: 'POST',
    data: formData,
    headers: {
      'Access-Token': auth,
      'biz-timestamp': time,
      'biz-route': encodeURIComponent((window.location.hash || '').replace(/^#/, '') || window.location.pathname),
      'biz-sign': hex_md5(`${'biz-timestamp'}${time}`).toLowerCase()
    }
  })
    .then(function (res) {
      return res.data || '';
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

/**
 * 执行上传文件
 * @params {object} file - 文件对象,name: 文件名，size: 文件大小，type: 文件类型
 * @params {String} scene - 场景编码，默认other
 */
function uploadObject2OSS({ file = {}, scene = 'other' }) {
  console.log('>>>上传文件', file, scene);

  return beforeUpload(file)
    .then(() => {
      return uploadFileMall({ file, scene });
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// 执行上传附件到OSS
function uploadAnnex2OSS({ file = {}, scene = 'other', type }) {
  console.log('>>>上传文件', file, scene);

  return beforeAnnexUpload(file, type)
    .then(() => {
      return uploadFileMall({ file, scene });
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// 将base64转换为blob
function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(',');

  let mime = arr[0].match(/:(.*?);/)[1];

  let bstr = atob(arr[1]);

  let n = bstr.length;

  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
// 将blob转换为file
function blobToFile(base64Data) {
  let theBlob = dataURLtoBlob(base64Data);
  theBlob.lastModifiedDate = new Date();
  let fileName = `${Date.parse(new Date())}${getRandomIntInclusive(1, 10000)}.png`;
  theBlob.name = fileName;
  return theBlob;
}

// var file = blobToFile(blob, imgName);

export default {
  calculate_object_name,
  uploadObject2OSS,
  filecCmpress,
  uploadAnnex2OSS,
  blobToFile,
  uploadFileMall,
  getUploadCfg,
  postObject2OSS
};



// WEBPACK FOOTER //
// ./src/utils/upload.js